import { useEffect, useState } from "react";
import { styles } from "../../../utils/styles/products-shopping-styles";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Head from "next/head";
import LinearProgress from "@mui/material/LinearProgress";
import { api } from "@/utils/Axios";
import { arFont, enFont } from "@/styles/font";
import dynamic from "next/dynamic";
import VerticalCarousel from "@/components/VerticalCarousel";
import { useI18n } from "@/i18n/I18nProvider";
import { getProductsText } from "../../../../locales/products";
const Calculator = dynamic(() => import("../../../components/Calculator.jsx"));
const PlaceCard = dynamic(() => import("@/components/PlaceCard"));
const PageCover = dynamic(() => import("@/components/PageCover"));
const IconTileSection = dynamic(() =>
  import("../../../components/mini-components/IconTileSection.jsx")
);
const ImgListSection = dynamic(() =>
  import("../../../components/mini-components/ImgListSection.jsx")
);

export default function Index() {
  const [data, setData] = useState(["initial"]);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState("");
  const [areas, setAreas] = useState([]);
  const [areaId, setAreaId] = useState("");
  const [loading, setLoading] = useState(false);

  const { t, locale } = useI18n();
  const products = getProductsText(locale);
  

  useEffect(() => {
    !categories.length &&
      api
       .post(
          `/services/categories/main?lang=${locale === "en" ? "en" : "ar"}`,
          {
            crmId: "6",
          }
        )
        .then(function (response) {
          response.data.shift(); 
          setCategories(response.data);
        })
        .catch(function (error) {});
    !cities.length &&
      api
        .post(`/services/cities?lang=${locale === "en" ? "en" : "ar"}`)
        .then(function (response) {
          setCities(response.data);
        })
        .catch(function (error) {});
    if (cityId) {
      api
         .post(`/services/cities/areas?lang=${locale === "en" ? "en" : "ar"}`, {
          cityId: +cityId,
        })
        .then(function (response) {
          setAreas(response.data);
        })
        .catch(function (error) {});
    }
    if (categoryId && cityId) {
      api
        .post(
         `/services/merchants/search?lang=${locale === "en" ? "en" : "ar"}`,
          {
            productId: "6",
            categoryId: `${categoryId}`,
            cityId: `${cityId}`,
            areaId: `${areaId || "0"}`,
            query: "",
          }
        )
        .then(function (response) {
          if (response.data.merchants.length) {
            setData(response.data.merchants);
          } else {
            setData(["not-initial"]);
          }
          setLoading(false);
        })
        .catch(function (error) {});
    }
  }, [categoryId, cityId, areaId]);
  return (
    <>
      <Head>
        <title>Products-Shopping</title>
        <meta name="" content="" />
      </Head>
      <Box sx={styles.container}>
        <PageCover
          color="#74357D"
          img="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cart.webp"
          title1={products.shopiing_page.cover.title1}
          title2={products.shopiing_page.cover.title2}
          description={products.shopiing_page.cover.description}
          formType="b"
          product="shopping"
          source={36}
        />
        <IconTileSection page="shopping"></IconTileSection>
        <ImgListSection></ImgListSection>
        <Box
          className="horizontal-safe-padding section-safe-padding-top"
          component="form"
          sx={{
            display: "flex",
            gap: 5,
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "flex-start" },
          }}
          autoComplete="off"
          noValidate
        >
          <Box sx={styles.inputWrapper}>
            <InputLabel sx={styles.label}>{t.form_labels.category}</InputLabel>
            <TextField
              value={categoryId || "default"}
              onChange={(e) => {
                setCategoryId(`${e.target.value}`);
                if (data[0] !== "initial" || cityId) {
                  setLoading(true);
                  setData([]);
                }
              }}
              name="category"
              type="text"
              sx={styles.input}
              select
              style={{ height: "45px" }}
              InputProps={{
                sx: {
                  height: "45px",
                  color: "grey",
                  lineHeight: "2",
                },
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      marginTop: 1,
                      maxHeight: 250,
                    },
                  },
                },
              }}
            >
              <MenuItem
                disabled
                value="default"
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {t.form_labels.cat_placeholder}
              </MenuItem>
              {categories &&
                categories.map((option) => (
                  <MenuItem
                    key={option.categoryId}
                    value={option.categoryId}
                    className={
                      locale == "en" ? enFont.className : arFont.className
                    }
                    sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                  >
                    {option.title}
                  </MenuItem>
                ))}
            </TextField>
          </Box>
          <Box sx={styles.inputWrapper}>
            <InputLabel sx={styles.label}>{t.form_labels.city}</InputLabel>
            <TextField
              value={cityId || "default"}
              onChange={(e) => {
                setCityId(`${e.target.value}`);

                if (categoryId) {
                  setLoading(true);
                  setData([]);
                }
                setAreaId("");
              }}
              name="governorate"
              type="text"
              sx={styles.input}
              select
              style={{ height: "45px" }}
              InputProps={{
                sx: {
                  height: "45px",
                  color: "grey",
                  lineHeight: "2",
                },
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      marginTop: 1,
                      maxHeight: 250,
                    },
                  },
                },
              }}
            >
              <MenuItem
                disabled
                value="default"
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {t.form_labels.city_placeholder}
              </MenuItem>
              {cities &&
                cities.map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={
                      locale == "en" ? enFont.className : arFont.className
                    }
                    sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
            </TextField>
          </Box>
          {areas.length > 0 && (
            <Box sx={styles.inputWrapper}>
              <InputLabel sx={styles.label}>{t.form_labels.area}</InputLabel>
              <TextField
                value={areaId || "default"}
                onChange={(e) => {
                  if (categoryId && cityId) {
                    setLoading(true);
                    setData([]);
                  }
                  setAreaId(`${e.target.value}`);
                }}
                name="governorate"
                type="text"
                sx={styles.input}
                select
                style={{ height: "45px" }}
                InputProps={{
                  sx: {
                    height: "45px",
                    color: "grey",
                    lineHeight: "2",
                  },
                }}
              >
                <MenuItem disabled value="default">
                  {t.form_labels.area_placeholder}
                </MenuItem>
                {areas &&
                  areas.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Box>
          )}
        </Box>
        {data.length && data[0] !== "initial" && data[0] !== "not-initial" ? (
          <VerticalCarousel
            hideDots={true}
            itemsArray={data}
            Component={PlaceCard}
            slidesPerView={4.3}
          ></VerticalCarousel>
        ) : loading == true ? (
          <Box sx={{ width: "85%", m: "auto", my: 5 }}>
            <LinearProgress />
          </Box>
        ) : data[0] == "not-initial" ? (
          <Box sx={{ textAlign: "center", my: 5 }}>{t.form_labels.case2}</Box>
        ) : (
          <Box sx={{ textAlign: "center", my: 5 }}>{t.form_labels.case1} </Box>
        )}

        <Calculator
          products_packages={t.calc_packages.consumer_finance}
          max_amount={1000000}
        />
      </Box>
    </>
  );
}